import type { BiographyFieldKey } from "@/api/buyers";

/**
 * The thirteen biography fields, in the order they render, with their labels.
 *
 * <p><b>Here rather than in `api/buyers.ts` deliberately.</b> This is
 * presentation config — an order and a set of labels — not API surface, and the
 * detail-page tests replace the whole `@/api/buyers` module with a stub, so a
 * runtime export living there breaks every component that reads it. The TYPES
 * stay with the DTOs, where they belong; types are erased and cost a mock
 * nothing.</p>
 *
 * <p>🔴 There is deliberately no age, life-stage, marital-status,
 * national-origin, religion, sex or disability field, and there must never be
 * one: this record feeds an underwriting decision and those are ECOA /
 * Regulation B protected classes. What the business means by "life stage" is
 * `availabilityAndCommitment`.</p>
 */
export const BIOGRAPHY_FIELDS: ReadonlyArray<{
  key: BiographyFieldKey;
  label: string;
}> = [
  { key: "professionalSummary", label: "Professional summary" },
  { key: "industryExperience", label: "Industry experience" },
  { key: "leadershipExperience", label: "Leadership experience" },
  { key: "operationsExperience", label: "Operations experience" },
  { key: "businessOwnershipExperience", label: "Business ownership" },
  { key: "education", label: "Education" },
  { key: "certificationsAndLicences", label: "Certifications & licences" },
  { key: "militaryService", label: "Military service" },
  { key: "notableAchievements", label: "Notable achievements" },
  { key: "transferableSkills", label: "Transferable skills" },
  { key: "geographicTies", label: "Geographic ties" },
  { key: "acquisitionMotivation", label: "Acquisition motivation" },
  { key: "availabilityAndCommitment", label: "Availability & commitment" },
];
